export enum ChatStatus {
  UNASSIGNED,
  OPEN,
  CLOSED,
}
